module.exports = __webpack_public_path__ + "img/bay.6472eab4.png";